var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4 1.38C15.5288 1.38 11.58 5.32885 11.58 10.2V12H14.82V10.2C14.82 7.11826 17.3182 4.62 20.4 4.62C23.4817 4.62 25.98 7.11826 25.98 10.2V12H29.22V10.2C29.22 5.32885 25.2711 1.38 20.4 1.38ZM13.2 17.04H27.6C29.787 17.04 31.56 18.813 31.56 21V30.0001C31.56 32.1871 29.7871 33.96 27.6 33.96H13.2C11.013 33.96 9.24 32.1871 9.24 30V21C9.24 18.813 11.0129 17.04 13.2 17.04ZM6 21C6 17.0236 9.22355 13.8 13.2 13.8H27.6C31.5764 13.8 34.8 17.0236 34.8 21V30.0001C34.8 33.9765 31.5765 37.2001 27.6 37.2001H13.2C9.22355 37.2001 6 33.9765 6 30V21Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bc4727f7dcd70a753960ab1aa7633230.svg";
export { ForwardRef as ReactComponent };